module.exports = __webpack_public_path__ + "img/help2.418ee546.png";